export const CHANGE_PAGE = 'CHANGE_PAGE'

export const CHANGE_PAGE_action = (data) => {
    return {
        type: CHANGE_PAGE,
        page: data
    }
}